import getEnvironDomain from "../utils/getEnvironDomain";

import strings from "../locales/strings";

const baseUrl = getEnvironDomain();

const mainMenuLinks = {
  "add-load": {
    label: strings.menu_addLoad,
    href: `https://loads.${baseUrl}/cargos/create/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ADD_LOAD",
  },
  automation: {
    label: strings.automationLink,
    href: `https://${baseUrl}/landings/integration/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_AUTOMATION",
  },
  "your-loads": {
    label: strings.menu_yourLoads,
    href: `https://loads.${baseUrl}/published?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOUR_LOADS",
  },
  "your-tenders": {
    label: strings.menu_yourTenders,
    href: `https://${baseUrl}/tenders/own/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOUR_TENDERS",
  },
  tenders: {
    label: strings.tenders,
    href: `https://${baseUrl}/tenders/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_TENDERS",
  },
  "add-tender": {
    label: strings.menu_addTenders,
    href: `https://${baseUrl}/tenders/add/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ADD_TENDER",
  },
  "your-orders": {
    label: strings.menu_yourOrders,
    href: `https://loads.${baseUrl}/orders/cargoOwner/Reconciliation/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOUR_ORDERS",
  },
  "owners-reports": {
    label: strings.menu_reports,
    href: `https://loads.${baseUrl}/orders/cargoOwner/reports/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_OWNERS_REPORTS",
  },
  "carriers-reports": {
    label: strings.menu_reports,
    href: `https://loads.${baseUrl}/orders/carrier/reports/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_CARRIERS_REPORTS",
  },
  "create-board": {
    label: strings.menu_createBoard,
    href: `https://${baseUrl}/boards/welcome/add/loads/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_CREATE_BOARD",
  },
  invitations: {
    label: strings.menu_invitations,
    href: `https://${baseUrl}/boards/applications/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_INVITATIONS",
  },
  "your-boards": {
    label: strings.menu_yourBoards,
    href: `https://${baseUrl}/boards/my/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOUR_BOARDS",
  },
  "you-participate": {
    label: strings.menu_youParticipate,
    href: `https://${baseUrl}/boards/participating/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOU_PARTICIPATE",
  },
  "trucks-search": {
    label: strings.menu_trucksSearch,
    href: `https://trucks.${baseUrl}/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_TRUCKS_SEARCH",
  },
  "active-carriers": {
    label: strings.menu_activeCarriers,
    href: `https://${baseUrl}/active-truckers/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ACTIVE_CARRIERS",
  },
  "rating-for-cargo-owners": {
    label: strings.menu_rating,
    href: `https://${baseUrl}/rating/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_RATING_FOR_CARGO_OWNERS",
  },
  "rating-for-carriers": {
    label: strings.menu_rating,
    href: `https://${baseUrl}/rating/?skip=0&groupTypeId=1&utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_RATING_FOR_CARRIERS",
  },
  "safety-memo": {
    label: strings.menu_safetyMemo,
    href: `https://academy.${baseUrl}/journal/safety/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_SAFETY_MEMO",
  },
  organizations: {
    label: strings.menu_organizations,
    href: `https://${baseUrl}/catalogs/organizations/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ORGANIZATIONS",
  },
  "partners-and-contracts": {
    label: strings.menu_partnersAndContracts,
    href: `https://${baseUrl}/catalogs/contractors/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_PARTNERS_AND_CONTRACTS",
  },
  "your-requisites": {
    label: strings.menu_yourRequisites,
    href: `https://${baseUrl}/catalogs/requisites/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOUR_REQUISITES",
  },
  "firm-lists": {
    label: strings.menu_firmLists,
    href: `https://${baseUrl}/catalogs/firms/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_FIRM_LIST",
  },
  "direction-lists": {
    label: strings.menu_directionLists,
    href: `https://${baseUrl}/catalogs/directions/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_DIRECTION_LISTS",
  },
  "add-truck": {
    label: strings.menu_addTruck,
    href: `https://trucks.${baseUrl}/EditPages/EditTruck.aspx/?ID=00000000-0000-0000-0000-000000000000&Action=Add&WindowMode=Popup&utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ADD_TRUCK",
  },
  "add-truck-new": {
    label: strings.menu_addTruck,
    href: ` https://trucks.${baseUrl}/trucks/create?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ADD_TRUCK",
  },
  "your-trucks": {
    label: strings.menu_yourTrucks,
    href: `https://trucks.${baseUrl}/published?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_YOUR_TRUCKS",
  },
  "orders-to-you": {
    label: strings.menu_ordersToYou,
    href: `https://loads.${baseUrl}/orders/carrier/Reconciliation/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_ORDERS_TO_YOU",
  },
  "loads-search": {
    label: strings.menu_exchange,
    href: `https://loads.${baseUrl}/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_LOADS_EXCHANGE",
  },
  "cargo-chains": {
    label: strings.menu_cargoChains,
    href: `https://loads.${baseUrl}/chains/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_CARGO_CHAINS",
  },
  "boards-search": {
    label: strings.menu_boardsLoadsSearch,
    href: `https://${baseUrl}/boards/public/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_BOARDS_SEARCH",
  },
  "boards-search-redirect": {
    label: strings.menu_boardsLoadsSearch,
    href: `https://${baseUrl}/webapi/boards/v2/boards/frontend/redirect/boardsCanView/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_BOARDS_SEARCH_REDIRECT",
  },
  boards: {
    label: strings.menu_boardsSearch,
    href: `https://${baseUrl}/boards/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_BOARDS",
  },
  catalogs: {
    label: strings.menu_catalogs,
    href: `https://${baseUrl}/catalogs/transport/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_CATALOGS",
  },
  drivers: {
    label: strings.menu_drivers,
    href: `https://${baseUrl}/catalogs/drivers/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_DRIVERS",
  },
  gps: {
    label: strings.menu_gps,
    href: `https://${baseUrl}/landings/ati-driver/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_GPS",
  },
  "time-slots": {
    label: strings.timeSlots,
    href: `https://${baseUrl}/timeslots?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_TIME_SLOTS",
  },
  checks: {
    label: strings.checkLink,
    href: `https://${baseUrl}/verification?utm_source=header&utm_campaign=new_header_carrier`,
    code: "MAIN_MENU_CHECKS",
  },
  "menu-guarantee-payment": {
    label: strings.guaranteePaymentLink,
    href: `https://${baseUrl}/landings/payment-guarantee?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_GUARANTEE_PAYMENT",
  },
  "docs-inbox": {
    label: strings.menu_inbox,
    href: `https://d.${baseUrl}/inbox/?utm_source=header&utm_medium=atidocs&utm_campaign=inbox`,
    code: "MAIN_MENU_DOCS_INBOX",
  },
  "docs-awaiting-decision": {
    label: strings.menu_awaitingDecision,
    href: `https://d.${baseUrl}/waiting?utm_source=header&utm_medium=atidocs&utm_campaign=waiting`,
    code: "MAIN_MENU_DOCS_AWAITING_DECISION",
  },
  "docs-closing": {
    label: strings.menu_closing,
    href: `https://d.${baseUrl}/inbox?contragent=10&utm_source=header&utm_medium=atidocs&utm_campaign=closing`,
    code: "MAIN_MENU_DOCS_CLOSING",
  },
  "docs-your-counterparties": {
    label: strings.menu_yourCounterparties,
    href: `https://d.${baseUrl}/roaming?tab=incoming&utm_source=header&utm_medium=atidocs&utm_campaign=invitations`,
    code: "MAIN_MENU_DOCS_YOUR_COUNTERPARTIES",
  },
  "docs-your-certificates": {
    label: strings.menu_yourCertificates,
    href: `https://d.${baseUrl}/certificates?utm_source=header&utm_medium=atidocs&utm_campaign=certificates`,
    code: "MAIN_MENU_DOCS_YOUR_CERTIFICATES",
  },
  "docs-invoice": {
    label: strings.menu_invoice,
    href: `https://d.${baseUrl}/create/document/invoice?utm_source=header&utm_medium=atidocs&utm_campaign=invoice`,
    code: "MAIN_MENU_DOCS_INVOICE",
  },
  "docs-application-agreement": {
    label: strings.menu_applicationAgreement,
    href: `https://d.${baseUrl}/create/document/order?utm_source=header&utm_medium=atidocs&utm_campaign=order`,
    code: "MAIN_MENU_DOCS_APPLICATION_AGREEMENT",
  },
  "docs-certificate-of-completion": {
    label: strings.menu_certificateOfCompletion,
    href: `https://d.${baseUrl}/create/document/act?utm_source=header&utm_medium=atidocs&utm_campaign=act`,
    code: "MAIN_MENU_DOCS_CERTIFICATE_OF_COMPLETION",
  },
  "docs-other-document": {
    label: strings.menu_otherDocument,
    href: `https://d.${baseUrl}/?popup=1&utm_source=header&utm_medium=atidocs&utm_campaign=another`,
    code: "MAIN_MENU_DOCS_OTHER_DOCUMENT",
  },
  courier: {
    label: strings.courierLink,
    href: `https://${baseUrl}/shipping/?utm_source=header&utm_campaign=new_header`,
    code: "MAIN_MENU_OWNERS_COURIER",
  },

"average-rates__statistika_rynka": {
    label: strings.menu_analitics_averageRates,
    href: `https://${baseUrl}/analytics/price?utm_source=header_statistika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_AVGPRICE",
  },
  "cargomap__statistika_rynka": {
    label: strings.menu_analitics_cargomap,
    href: `https://${baseUrl}/analytics/cargo-map?utm_source=header_statistika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_CARGOMAP",
  },
  "profitdirections__statistika_rynka": {
    label: strings.menu_analitics_profitdirections,
    href: `https://${baseUrl}/analytics/profit-directions?utm_source=header_statistika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_PROFITDIRECTIONS",
  },
  "index__statistika_rynka": {
    label: strings.menu_analitics_index,
    href: `https://${baseUrl}/analytics/index?utm_source=header_statistika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_STATISTIKA_RYNKA_INDEX",
  },

  "average-rates__servisy_dlya_analitiki": {
    label: strings.menu_analitics_averageRates,
    href: `https://${baseUrl}/analytics/price?utm_source=header_servisy_dlya_analitiki&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_AVGPRICE",
  },
  "cargomap__servisy_dlya_analitiki": {
    label: strings.menu_analitics_cargomap,
    href: `https://${baseUrl}/analytics/cargo-map?utm_source=header_servisy_dlya_analitiki&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_CARGOMAP",
  },
  "profitdirections__servisy_dlya_analitiki": {
    label: strings.menu_analitics_profitdirections,
    href: `https://${baseUrl}/analytics/profit-directions?utm_source=header_servisy_dlya_analitiki&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_PROFITDIRECTIONS",
  },
  "index__servisy_dlya_analitiki": {
    label: strings.menu_analitics_index,
    href: `https://${baseUrl}/analytics/index?utm_source=header_servisy_dlya_analitiki&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_SERVISY_DLYA_ANALITIKI_INDEX",
  },

  "average-rates__dinamika_rynka": {
    label: strings.menu_analitics_averageRates,
    href: `https://${baseUrl}/analytics/price?utm_source=header_dinamika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_AVGPRICE",
  },
  "cargomap__dinamika_rynka": {
    label: strings.menu_analitics_cargomap,
    href: `https://${baseUrl}/analytics/cargo-map?utm_source=header_dinamika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_CARGOMAP",
  },
  "profitdirections__dinamika_rynka": {
    label: strings.menu_analitics_profitdirections,
    href: `https://${baseUrl}/analytics/profit-directions?utm_source=header_dinamika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_PROFITDIRECTIONS",
  },
  "index__dinamika_rynka": {
    label: strings.menu_analitics_index,
    href: `https://${baseUrl}/analytics/index?utm_source=header_dinamika_rynka&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_DINAMIKA_RYNKA_INDEX",
  },

  "average-rates__rynok_v_cifrah": {
    label: strings.menu_analitics_averageRates,
    href: `https://${baseUrl}/analytics/price?utm_source=header_rynok_v_cifrah&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_AVGPRICE",
  },
  "cargomap__rynok_v_cifrah": {
    label: strings.menu_analitics_cargomap,
    href: `https://${baseUrl}/analytics/cargo-map?utm_source=header_rynok_v_cifrah&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_CARGOMAP",
  },
  "profitdirections__rynok_v_cifrah": {
    label: strings.menu_analitics_profitdirections,
    href: `https://${baseUrl}/analytics/profit-directions?utm_source=header_rynok_v_cifrah&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_PROFITDIRECTIONS",
  },
  "index__rynok_v_cifrah": {
    label: strings.menu_analitics_index,
    href: `https://${baseUrl}/analytics/index?utm_source=header_rynok_v_cifrah&utm_campaign=new_header`,
    code: "MAIN_MENU_ANALYTICS_RYNOK_V_CIFRAH_INDEX",
  },
};

export default mainMenuLinks;
